module.exports = __webpack_public_path__ + "img/szjc3.9b500464.png";